<div class="row animated fadeInRight" *ngIf="mostrarFormulario">
    <app-lfsa-card-v2 [innTemplateButton]="innTemplateButtonForm" [innTemplate]="enviarTemplateForm"
        [titulo]="'Autorizacion'" [modulo]="'Admin Seguridad'" [tituloCard]="'Guardar Autorizacion'">
    </app-lfsa-card-v2>

    <ng-template #innTemplateButtonForm>
    </ng-template>

    <ng-template #enviarTemplateForm>
        <form [formGroup]="formulario" novalidate class="form-group">
            <div class="row">
                <div class="form-group col-md-6">
                    <app-lfsa-input [placeholder]="'Ingrese Nombre'" [label]="'Nombre'" [id]="'name'"
                        formControlName="name" [control]="formulario.get('name')"></app-lfsa-input>
                </div>
                <div class="form-group col-md-6">
                    <app-lfsa-combo-box [opcion]="'application'" [idOpcion]="'application'" [comboBox]="cmbAplication"
                        formControlName="application" [control]="formulario.get('application')" [label]="'Aplicación'"
                        [id]="'application'">
                    </app-lfsa-combo-box>
                </div>
            </div>
            <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones ( $event )"
                [textBoton]="textBoton"></app-lfsa-botones-formulario>
        </form>
    </ng-template>
</div>

<div class="row animated fadeInRight" *ngIf="!mostrarFormulario">
    <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate" [titulo]="'Autorizacion'"
        [modulo]="'Admin Seguridad'" [tituloCard]="'Listar Autoritys'">
    </app-lfsa-card-v2>

    <ng-template #innTemplateButton>
        <div class="col-md-6">
            <div class="pagetitle">
                <div class="btn-group-justified btn-group" style="float: right;">
                    <a class="btn btn-outline-success" (click)="nuevo()">
                        <span class="fa fa-plus"></span>
                        {{DAT_BTNS.agregarAutorizacion}}</a>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #enviarTemplate>
        <section class="section">
            <div class="row">
                <div class="col-md-12 ">
                    <!-- <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2> -->
                    <ag-grid-angular [floatingFilter]="true" class="{{diccionarioModulo.agGrid.class}}" #agGrid
                        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
                        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
                        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs"
                        [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </section>
    </ng-template>
</div>
